import { Link } from 'react-router-dom'

import { DashboardModel } from '@/types'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useBusiness } from '@/contexts/BusinessContext'

interface RecentSalesProps {
  orders: DashboardModel.RecentSale[]
  className?: string
}

export const RecentSales = ({ orders, className }: RecentSalesProps) => {
  const { formatCurrency } = useBusiness()
  const items = orders ?? []

  return (
    <Card className={className}>
      <CardHeader className="flex-row items-start justify-between gap-3 space-y-0">
        <div>
          <CardTitle className="w-fit text-sm font-semibold underline decoration-faint decoration-dotted underline-offset-4">Recent sales</CardTitle>
          <CardDescription className="mt-1 text-xs">{items.length} latest orders</CardDescription>
        </div>
        <Button variant="link" size="sm" asChild>
          <Link to="/orders">View all</Link>
        </Button>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="py-10 text-center text-sm text-muted-foreground">No sales yet.</p>
        ) : (
          <ul className="divide-y divide-border-subtle">
            {items.map((sale, i) => (
              <li key={i} className="flex items-center gap-3 py-2.5 first:pt-0 last:pb-0">
                {sale.image_path ? (
                  <img src={sale.image_path} alt="" className="size-8 shrink-0 rounded-full object-cover" />
                ) : (
                  <span className="grid size-8 shrink-0 place-items-center rounded-full bg-fill text-xs font-semibold uppercase text-ink">
                    {sale.name?.charAt(0) ?? '?'}
                  </span>
                )}
                <p className="min-w-0 flex-1 truncate text-sm font-medium text-ink">{sale.name}</p>
                <p className="shrink-0 text-sm tabular-nums text-ink">{formatCurrency(sale.amount)}</p>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  )
}
